<template>
  <div class="container ">
    <div class="row">
      <h1>Benutzer aktivieren</h1>
        <div class="user__item col-12 border border-danger p-4 mt-2" v-for="user in mieterToActivate">
          <div class="row">
            <div class="col-12 text-left">
              <h4 class="red-text">Wohnungssuchender</h4>
            </div>
          </div>
          <div class="row">
            <div class="user__item--block d-flex flex-column col text-left">
              <p class="user__item--block-name">Name:</p>
              <p>{{user.vorname}} {{user.nachname}}</p>
            </div>
            <div class="user__item--block d-flex flex-column col text-left">
              <p class="user__item--block-name">Status:</p>
              <p>{{user.status}}</p>
            </div>
            <div class="user__item--block d-flex flex-column col text-left">
              <p class="user__item--block-name">Institution / Untergruppe:</p>
              <p>{{user.institution}} / {{user.institutionuntergruppe}}</p>
            </div>
            <div class="user__item--block d-flex flex-column col text-left">
              <p class="user__item--block-name">Nationalität:</p>
              <p>{{user.nationalitaetText}}</p>

            </div>
            <div class="user__item--block d-flex flex-column col text-left">
              <p class="user__item--block-name">Aufenthalt:</p>
              <p v-if="user.aufenthaltvon && user.aufenthaltbis">{{$func.formateDateFromDB(user.aufenthaltvon )}}<br> bis<br> {{$func.formateDateFromDB(user.aufenthaltbis)}}</p>
            </div>
            <div class="user__item--block flex-column col text-left">
              <p class="user__item--block-name">mit Familie:</p>
              <p>{{user.mitfamilie}}</p>
            </div>
            <div class="user__item--block flex-column col text-left">
              <p class="user__item--block-name">Sonstiges:</p>
              <p>{{user.sonstiges}}</p>
            </div>
          </div>
          <div class="row mt-5">
          <div class="btn__wrapper col-12">
            <div class="btn btn-danger" v-on:click="declineUser(user.account, user.activationhash, user.email)">Ablehnen</div>
            <div class="btn btn-danger" v-on:click="acceptUser(user.account, user.activationhash, user.email)">Annehmen</div>
          </div>

          </div>


        </div>
        <div class="user__item col-12 border border-danger p-4 mt-2" v-for="user in vermieterToActivate">
          <div class="row">
            <div class="col-12 text-left">
              <h4 class="red-text">Vermieter</h4>
            </div>
          </div>
          <div class="row">
            <div class="user__item--block d-flex flex-column col text-left">
              <p class="user__item--block-name">Name:</p>
              <p>{{user.vorname}} {{user.nachname}}</p>
            </div>
            <div class="user__item--block d-flex flex-column col text-left">
              <p class="user__item--block-name">Email:</p>
              <p>{{user.email}}</p>
            </div>
            <div class="user__item--block d-flex flex-column col text-left">
              <p class="user__item--block-name">Ort:</p>
              <p><span v-if="user.plz">{{user.plz}}, </span>{{user.ort}}</p>
            </div>
            <div class="user__item--block flex-column col text-left">
              <p class="user__item--block-name">Straße:</p>
              <p>{{user.strasse}}</p>
            </div>
            <div class="user__item--block flex-column col text-left" v-if="user.telefon && user.mobil">
              <p class="user__item--block-name" v-if="">Telefon/Handy:</p>
              <p>{{user.telefon}}</p>
              <p>{{user.mobil}}</p>
            </div>
            <div class="user__item--block flex-column col text-left" v-if="user.telefon && user.mobile == ''">
              <p class="user__item--block-name" v-if="">Telefon:</p>
              <p>{{user.telefon}}</p>
            </div>
            <div class="user__item--block flex-column col text-left" v-if="user.telefon == '' && user.mobil">
              <p class="user__item--block-name" v-if="">Handy:</p>
              <p>{{user.mobil}}</p>
            </div>
          </div>
          <div class="row mt-5">
          <div class="btn__wrapper col-12">
            <div class="btn btn-danger" v-on:click="declineUserVermieter(user.account, user.activationhash, user.email)">Ablehnen</div>
            <div class="btn btn-danger" v-on:click="acceptUserVermieter(user.account, user.activationhash, user.email)">Annehmen</div>
          </div>

          </div>


        </div>
    </div>
  </div>

</template>

<script>
import UserService from "@/services/UserService";
import EmailService from "@/services/EmailService";
import { mdbBtn, mdbInput, mdbDatePicker, mdbSelect, mdbSelectOption } from 'mdbvue';
import settings from "@/components/Settings.json";
export default {
  name: "ActivateUser",
  components: {
    UserService,
    mdbBtn,
    mdbInput
  },
  data () {
    return {
      mieterToActivate: Array,
      vermieterToActivate: Array,
      nationalitaet: [],
    }
  },
  methods: {
    acceptUserVermieter(id, hash, email){
      UserService.activateUser(id, hash, 2).then(response => {
        UserService.getUserToActivate().then(response => {
          this.mieterToActivate = response.data[0]; // <--- set the events when returned
          this.vermieterToActivate = response.data[1]; // <--- set the events when returned
        })
        EmailService.sendMail("AktivierungVermieter", "Bestätigung Ihrer Anmeldung", email, null, true)
      })
    },
    declineUserVermieter(id, hash, email){
      UserService.declineUser(id, hash, 2).then(response => {
        UserService.getUserToActivate().then(response => {
          this.mieterToActivate = response.data[0]; // <--- set the events when returned
          this.vermieterToActivate = response.data[1]; // <--- set the events when returned
        })
        EmailService.sendMail("LoeschungVermieter", "Ihr Account konnte nicht aktiviert werden", email, null, true)
      })
    },
    acceptUser(id, hash, email){
      UserService.activateUser(id, hash,1).then(response => {
        UserService.getUserToActivate().then(response => {
          this.mieterToActivate = response.data[0]; // <--- set the events when returned
          this.vermieterToActivate = response.data[1]; // <--- set the events when returned
        })
        EmailService.sendMail("AktivierungMieter", "Bestätigung Ihrer Anmeldung", email, null, true)
      })
    },
    declineUser(id, hash, email){
      UserService.declineUser(id, hash,1).then(response => {
        UserService.getUserToActivate().then(response => {
          this.mieterToActivate = response.data[0]; // <--- set the events when returned
          this.vermieterToActivate = response.data[1]; // <--- set the events when returned
        })
        EmailService.sendMail("LoeschungMieter", "Ihr Account konnte nicht aktiviert werden", email, null, true)
      })
    },
    nationality(user) {
      let obj = this.nationalitaet.find((o, i) => {
        if(o.value === user.nationalitaet){
          user.nationalitaetText = o.text;
          return true
        }
      });
    }
  },
  mounted() {
    this.nationalitaet = settings.Settings[0].country
    UserService.getUserToActivate().then(response => {
      this.mieterToActivate = response.data[0]; // <--- set the events when returned
      this.vermieterToActivate = response.data[1]; // <--- set the events when returned
      for (let i = 0; i < this.mieterToActivate.length; i++) {
        this.nationality(this.mieterToActivate[i]);
      }
    })
  },
};
</script>

<style scoped lang="scss">

</style>
